import React from 'react';
import { motion } from 'framer-motion';
import './YoutubeFeatures.css';

const YoutubeFeatures = () => {
  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <section className="yt-features-section">
      
      {/* Feature 1 */}
      <motion.div 
        className="yt-feature-card feat-1"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={cardVariants}
      >
        <div className="yt-feature-visual-left">
           <img src="/youtube-assets/scales_shield.png" alt="Scales of Justice and Shield" className="yt-3d-image" />
        </div>
        <div className="yt-feature-content">
          <p className="yt-feature-subtitle">TRANSPARENT & FAIR</p>
          <h2 className="yt-feature-title">
            FAIR CLAIMS.<br/>TRANSPARENT<br/>
            <span className="gradient-text-purple-pink">PAYOUTS.</span>
          </h2>
          <p className="yt-feature-desc">
            No hidden fees. No confusing splits.
            Just fair, upfront payouts you can trust.
          </p>
          <a 
            href="https://dashboard.fttunes.com/register.php"
            target="_blank"
            rel="noopener noreferrer"
            className="yt-btn-secondary"
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            SEE DETAILS <span className="arrow">→</span>
          </a>
        </div>
        <div className="yt-feature-visual-right">
          <div className="yt-earnings-widget">
            <div className="earnings-label">Earnings</div>
            <div className="earnings-amount">$4,680.00</div>
            <div className="earnings-growth">+52%</div>
            <div className="earnings-chart">
               <svg viewBox="0 0 100 30" className="chart-svg">
                  <path d="M0,25 L15,15 L30,20 L45,10 L60,18 L80,5 L100,15" fill="none" stroke="#b637f9" strokeWidth="2" />
               </svg>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Feature 2 */}
      <motion.div 
        className="yt-feature-card feat-2"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={cardVariants}
      >
        <div className="yt-feature-content">
          <p className="yt-feature-subtitle">SMART & SECURE</p>
          <h2 className="yt-feature-title">
            AUTOMATIC<br/>PROTECTION.<br/>
            <span className="gradient-text-purple-pink">BUILT-IN EARNINGS.</span>
          </h2>
          <p className="yt-feature-desc">
            We protect your content automatically and help
            you earn from every play, so you can focus on
            the music.
          </p>
          <a 
            href="https://dashboard.fttunes.com/register.php"
            target="_blank"
            rel="noopener noreferrer"
            className="yt-btn-secondary"
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            HOW IT WORKS <span className="arrow">→</span>
          </a>
        </div>
        <div className="yt-feature-visual-right-large">
           <img src="/youtube-assets/padlock_play.png" alt="Padlock and Play Button" className="yt-3d-image" />
           <div className="yt-protection-list">
             <div className="prot-item">
               <div className="prot-icon check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"></polyline></svg></div>
               <span>Protected</span>
             </div>
             <div className="prot-item">
               <div className="prot-icon shield"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></div>
               <span>Content ID Monitoring</span> <span className="status">Active</span>
             </div>
             <div className="prot-item">
               <div className="prot-icon shield"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg></div>
               <span>Copyright Protection</span> <span className="status">Active</span>
             </div>
             
             <div className="yt-small-earnings">
                <div className="earnings-label">Earnings</div>
                <div className="earnings-amount">$4,680.00</div>
                <div className="earnings-growth">+52%</div>
                <div className="earnings-chart">
                  <svg viewBox="0 0 100 30" className="chart-svg">
                      <path d="M0,25 L20,15 L40,20 L60,10 L80,18 L100,5" fill="none" stroke="#b637f9" strokeWidth="2" />
                  </svg>
                </div>
             </div>
           </div>
        </div>
      </motion.div>

      {/* Feature 3 */}
      <motion.div 
        className="yt-feature-card feat-3"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={cardVariants}
      >
        <div className="yt-feature-visual-left">
           <div className="yt-channel-perf-widget">
             <div className="perf-header">
               <span>Channel Performance</span>
               <select className="perf-select"><option>Last 30 Days</option></select>
             </div>
             <div className="perf-stats">
               <div className="perf-label">Views</div>
               <div className="perf-amount">2.4M</div>
               <div className="perf-growth">+62.6%</div>
             </div>
             <div className="yt-laptop-bar-chart">
                {/* Bars placeholder */}
                {[...Array(16)].map((_, i) => (
                  <div key={i} className="lap-bar" style={{height: `${Math.random() * 80 + 20}%`}}></div>
                ))}
                <div className="perf-play-overlay">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
             </div>
           </div>
        </div>
        <div className="yt-feature-content">
          <p className="yt-feature-subtitle">REAL-TIME CONTROL</p>
          <h2 className="yt-feature-title">
            CONTROL YOUR<br/>REACH. PROTECT<br/>
            <span className="gradient-text-purple-pink">YOUR RIGHTS.</span>
          </h2>
          <p className="yt-feature-desc">
            Track performance, manage permissions,
            and protect your music — all in one place.
          </p>
          <a 
            href="https://dashboard.fttunes.com/register.php"
            target="_blank"
            rel="noopener noreferrer"
            className="yt-btn-secondary"
            style={{ textDecoration: 'none', display: 'inline-block' }}
          >
            DASHBOARD <span className="arrow">→</span>
          </a>
        </div>
      </motion.div>

    </section>
  );
};

export default YoutubeFeatures;
